import { axiosInstanceFast } from "./axiosInstance";

export const storeSovereigntySummary = async () => {
  const response = await axiosInstanceFast.get(
    "/rdd/api/v1/stores/sovereignty-summary",
  );
  return response.data.data;
};

export const storeSummary = async () => {
  const response = await axiosInstanceFast.get(
    "/rdd/api/v1/stores/get-summary",
  );
  return response.data.data;
};

export const getFileData = async (file_id: number, source_type?: string) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/files/get-details",
    {
      file_id,
      source_type,
    },
  );
  return response.data.data;
};

export const getEmailData = async (email_id: number) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/emails/get-details",
    {
      email_id,
    },
  );
  return response.data.data;
};

export const getSensitiveFiles = async (
  data: {
    sensitivity: string;
    sub_category: string;
    limit?: number;
    page?: number;
    service?: string;
    silo_name?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    cursor?: string;
  },
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/files/sensitive-list";

  if (!data.limit) {
    data.limit = 10;
  }
  if (!data.page) {
    data.page = 0;
  }
  const response = await axiosInstanceFast.post(url, data, { signal });
  // return response.data.data;
  return response.data;
};

export const dataClassification = async (data: {
  classification: string;
  source_service: string;
  username?: string;
  type?: string;
  is_sensitive?: string;
}) => {
  const url = "/rdd/api/v1/data/classification-list";
  const response = await axiosInstanceFast.post(url, data);
  return response.data.data;
};

export const dataClassificationSummary = async (data: {
  classification: string;
  source_service: string;
  type: string;
  username?: string;
  is_sensitive?: string;
  is_external?: number;
}) => {
  const url = "/rdd/api/v1/data/classification-summary-list";
  const response = await axiosInstanceFast.post(url, data);
  return response.data.data;
};

export const dataSubClassification = async (data: {
  req_type: string;
  classification: string;
  service?: string;
  silo_name?: string;
  user_name?: string;
  user_id?: number;
  is_external?: number;
}) => {
  const url = "rdd/api/v1/data/sub-classification";
  const response = await axiosInstanceFast.post(url, data);
  return response.data.data;
};

export const getRiskSummary = async () => {
  const response = await axiosInstanceFast.get("/rdd/api/v1/data/risk-summary");
  return response.data.data;
};

export const getOpenAccessFiles = async (
  data: {
    is_sensitive?: string;
    sensitivity?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/files/open-access",
    data,
    { signal },
  );
  return response.data.data;
};

export const getDataDeletedBeforeRetention = async (
  data: {
    page_size?: number;
    page?: number;
    source?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/files/deleted-before-retention",
    data,
    { signal },
  );
  return response.data.data;
};

export const getDataExpiredRetention = async (
  data: {
    page_size?: number;
    page?: number;
    source?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/files/expired-retention-list",
    data,
    { signal },
  );
  return response.data.data;
};

export const getExternallySharedFiles = async (
  data: {
    page_size?: number;
    page?: number;
    source_type?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    cursor?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/files/public-sensitive-list",
    data,
    { signal },
  );
  return response.data;
};

export const getSensitiveDataAccessUsers = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/user/sensitive-access",
    {},
    { signal },
  );
  return response.data.data;
};

export const getSensitiveDataExternalUsers = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/user/sensitive-public",
    {},
    { signal },
  );
  return response.data.data;
};

export const getDuplicateFiles = async (
  data: {
    file_ids: number[];
    source?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/files/duplicate-details",
    data,
    { signal },
  );
  return response.data.data;
};

export const getSiloList = async (
  data: {
    source?: string;
    limit?: number;
    page?: number;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    is_sensitive?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/file/get-silo",
    data,
    { signal },
  );
  // return response.data.data;
  return response.data;
};

export const getDatabaseList = async (
  data: {
    source?: string;
    limit?: number;
    page?: number;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    is_sensitive?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/database/get-database",
    data,
    { signal },
  );
  // return response.data.data;
  return response.data;
};

export const getDatabaseTableList = async (
  data: {
    source?: string;
    db_name?: string;
    limit?: number;
    page?: number;
    user_name?: string;
    sensitivity?: string;
    domain?: string;
    is_sensitive?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    is_external?: number;
    plugin_id?: string;
    extension?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/database/get-list",
    data,
    { signal },
  );
  // return response.data.data;
  return response.data;
};

export const getDatabaseTableData = async (
  table_id: number,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/database/get-details",
    { table_id: table_id },
    { signal },
  );
  return response.data.data;
};

export const getEmailAccountList = async (
  data: {
    source?: string;
    limit?: number;
    page?: number;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    is_sensitive?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/emails/get-users-list",
    data,
    { signal },
  );
  // return response.data.data;
  return response.data;
};

export const getConversionUsers = async (
  data: {
    source?: string;
    page_size?: number;
    page?: number;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    is_sensitive?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/conversation/get-users-list",
    data,
    { signal },
  );
  // return response.data.data;
  return response.data;
};

export const getConversionList = async (
  data: {
    source?: string;
    email_address?: string;
    limit?: number;
    page?: number;
    sensitivity?: string;
    domain?: string;
    is_sensitive?: string;
    is_external?: number;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    plugin_id?: string;
    extension?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/conversation/get-list",
    data,
    { signal },
  );
  // return response.data.data;
  return response.data;
};

export const getConversionData = async (
  conversation_id: number,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/conversation/get-details",
    // { conversation_id:conversation_id },
    { table_id: conversation_id },
    { signal },
  );
  return response.data.data;
};

export const getDataSettings = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post(
    "/rdd/backend/v1/get-data-settings",
    {},
    { signal },
  );
  return response.data.data;
};

export const getDomainTypeSummary = async (
  data: {
    sensitivity?: string;
    classification?: string;
    is_sensitive?: string;
    service?: string;
    silo_name?: string;
    user_name?: string;
    user_id?: number;
    is_external?: number;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/data/sensitive-type-summary",
    data,
    { signal },
  );
  return response.data.data;
};

export const initiateFileRescan = async (
  data: {
    file_id?: number;
    silo?: string;
    service?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/sources/set-file-rescan",
    data,
    { signal },
  );
  return response.data.data;
};

export const initiateDbRescan = async (
  data: {
    table_id?: number;
    db_name?: string;
    service?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/sources/set-database-rescan",
    data,
    { signal },
  );
  return response.data.data;
};

export const getTaxonomyCount = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/taxonomy-count",
    {},
    { signal },
  );
  return response.data.data;
};

export const updateUserClassification = async (
  data: {
    type: string;
    id: number;
    user_classification: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/update-user-classification",
    data,
    { signal },
  );
  return response.data.data;
};

export const updateUserClass = async (
  data: {
    file_id: number;
    user_classification: string;
    source: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/backend/v1/add-user-classification",
    data,
    { signal },
  );
  return response.data.data;
};

export const getGloballySharedSummary = async (
  data: {
    source_type: string[];
    is_sensitive: boolean;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/globally-shared-summary",
    data,
    { signal },
  );
  return response.data.data;
};

export const getInstalledPluginList = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get(
    "/plugin/get-installed-plugin-list",
    { signal },
  );
  return response.data.data;
};

export const getGenericUsersList = async (
  data: {
    page?: number;
    source: string;
    page_size?: number;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    is_sensitive?: string;
    data_source?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/generic/get-users-list",
    data,
    { signal },
  );
  return response.data;
};

export const getGenericList = async (
  data: {
    source: string;
    silo_name?: string;
    user_name?: string;
    user_id?: number;
    sensitivity?: string;
    classification?: string;
    limit: number;
    page: number;
    is_sensitive?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    is_external?: number;
    plugin_id?: string;
    extension?: string;
  },
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/generic/get-list";
  const response = await axiosInstanceFast.post(url, data, { signal });
  return response.data;
};

export const getGenericDetails = async (
  data: {
    generic_id: string;
    product?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/generic/get-details",
    data,
    { signal },
  );
  return response.data.data;
};
